<template>
	<div class="header-page" :class="{'background1': background1, 'isss': isShow}" @mouseleave="navActiveIndex = -1">
		<div class="navCard_containerView">
			<div class="navCard_wrapperView">
				<div class="navCard_navLeftView"></div>
				<div class="navCard_navCenterView">
					<div class="navCard_sectionLeftView">
						<img v-if="config.site_logo" :src="config.site_logo" class="navCard_logoIcon" alt="logoIcon" />
						<ul class="navCard_navListView">
							<li class="navLink_navLinkView " :class="{'navLink_isActiveView': navIndex == -1}"
								@click="link('/Home', -1)" @mouseenter="navActiveIndex = -1">
								<div class="navLink_nameText">{{$t('main.homeText')}}</div>
							</li>
							<li class="navLink_navLinkView" :class="{'navLink_isActiveView': navIndex == 1}"
								@mouseenter="navActiveIndex = 1" @click="link('/sport', 1)">
								<div class="navLink_nameText">{{$t('main.game.ty.name')}}</div>
							</li>
							<li class="navLink_navLinkView " :class="{'navLink_isActiveView': navIndex == 2}"
								@mouseenter="navActiveIndex = 2" @click="link('/casino', 2)">
								<div class="navLink_nameText">{{$t('main.game.zr.name')}}</div>
							</li>
							<li class="navLink_navLinkView " :class="{'navLink_isActiveView': navIndex == 3}"
								@mouseenter="navActiveIndex = 3" @click="link('/chess', 3)">
								<div class="navLink_nameText">{{$t('main.game.qp.name')}}</div>
							</li>
							<li class="navLink_navLinkView " :class="{'navLink_isActiveView': navIndex == 4}"
								@mouseenter="navActiveIndex = 4" @click="link('/gaming', 4)">
								<div class="navLink_nameText">{{$t('main.game.dj.name')}}</div>
							</li>
							<li class="navLink_navLinkView " :class="{'navLink_isActiveView': navIndex == 5}"
								@mouseenter="navActiveIndex = 5" @click="link('/lottery', 5)">
								<div class="navLink_nameText">{{$t('main.game.cp.name')}}</div>
							</li>
							<li class="navLink_navLinkView  " :class="{'navLink_isActiveView': navIndex == 6}"
								@mouseenter="navActiveIndex = 6" @click="link('/slot', 6)">
								<div class="navLink_nameText">{{$t('main.game.dz.name')}}</div>
							</li>
							<li class="navLink_navLinkView  navLink_isLoginView" style="margin-right: 0px;"
								:class="{'navLink_isActiveView': navIndex == 7}" @mouseenter="navActiveIndex = 7"
								@click="link('/fishing', 7)">
								<div class="navLink_nameText">{{$t('main.game.by.name')}}</div>
							</li>
							
						</ul>
					</div>
					<div class="navCard_sectionRightView">
						<div id="popoverCon"  style="display:flex;align-items: center;">
							<div class="dddssas">
								<ul class="navCard_navListView dddssa">
									<li class="iconLink_iconLinkView" @click="linkCs">
										<my-img srcText="header/icon1.png" classText="iconLink_navbarIcon" alt="icon"></my-img>
										<div class="iconLink_navbarName">{{$t('main.header.kf')}}</div>
									</li>
									<li class="iconLink_iconLinkView" @click="link('/agent', -1)">
										<my-img srcText="header/icon2.png" classText="iconLink_navbarIcon" alt="icon"></my-img>
										<div class="iconLink_navbarName">{{$t('main.header.hy')}}</div>
									</li>
									<li class="iconLink_iconLinkView" @click="link('/activity', -1)">
										<my-img srcText="header/icon4.png" classText="iconLink_navbarIcon" alt="icon"></my-img>
										<div class="iconLink_navbarName">{{$t('main.header.yh')}}</div>
									</li>
									<li class="iconLink_iconLinkView" @click="link('/app', -1)">
										<my-img srcText="header/icon5.png" classText="iconLink_navbarIcon" alt="icon"></my-img>
										<div class="iconLink_navbarName">APP</div>
									</li>
								</ul>
							</div>
							<div v-if="!userInfo.name" style="margin-left:24px">
								<div class="userInfo_user_warp userInfo_default_cursor">
									<div class="login_userInfo"><input type="text"
											style="height: 28px !important;border: none !important;"
											class="ant-input inputItem_inputItemView  login_inputbox" v-model="name"
											:placeholder="$t('main.from.username')" maxlength="32">
										<div class="login_pwdBox__3rNpO"><input type="password" :placeholder="$t('main.from.password')"
												v-model="password" class="login_inputbox" maxlength="32">
											<!-- <div class="login_forgetstyle__214Xm">忘记？</div> -->
										</div>
										<div class="image_imageContainer image_cover login_loginBtn" @click="linkLogin"
											style="width: 54px; cursor: inherit; background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAA4BAMAAADqVwAfAAAAJ1BMVEVHcExVnf5Wnv5VnP9cpf9apv5fsP9Vnf5Qlf1Njv1JiPxGgvxCfPu5eKQgAAAABXRSTlMA1ZxiG/pGzkcAAANOSURBVEjHnVZNb9NAEN1+HDgWAUW9VeJLvUEFonAqIARnwPa5SPYZKNaGIxTJm97oBdscuTTrX4CdP4CcH8W8mfVHUghJXr2zM+/N27WTqF6lGmzub0dzcXTjUF3As/+Y2Hh/1vU0Wgg3p13rUbSCbyNaGHd7ttuL2952rifRErjafvTbkb+oyY+ODtvN/NAnhFEYEu9HiBSIxkVZ6FJ0tdtdI1NI8D3QXuhxRAWOSsfjIhy5Dx8SNC+kGaJrYIesF4oJs+fvsu0Br++xGUYglOBLwt1YWbjX/IF408DdNUaB3wa3CN+jtzRwl8+Xt70h263Yiz0v8OKACMqQxuACTj0Xg7b04lf0aAEDLuoOYo1CKA02CISGyhU1eIdqI2ZoMTRFILkk/VQa7qq1WOtAa/bFyLRkyCmBwnqMTGKgt9QL3ehamgJeBHngyoDbMYldxx/VQ70CjtWdVWwf1PVVbO/VAEjMYC6SWYhtoBPR+h29vPU2nDK0lUkQcZkEgQnj8gHYGT1RCcvcKc0GN9zFhH2im0Y3ykxjYObD6cqshNY2NCldaSppGyVMl0PYsmGaZkNxwUg5gyoC6lRARaupHeQ0MiDNuELJlNMwUq4yXib7pvacQRRomTQwR5XoTnXNZ+pR1pX/xox+ol5mK+CrupSNRjkNRp73YkP2sxxVnr9T6znDsZLKZJm0rNmOpznbVRun1o6szTli5mnESd6yFEcjx1t7Tu/GT9ZKo2ux/aRdrqMpfKf/kwd2aZyQbU3SgkaJq0RSOq7oRNAFKSRt4XV/WlVVWRVFUVIsy6KgUjKKUFAXTsM459f+Dq1AKhq4ByvwjFCgu+RCFiF85vfbwY+qj7I3lTMkL/XrWN6mp9VSOJe3qdor6rqqx3SNESr81bUQTKJkBkn5pTkp5KzWDMzd6Eenn28155JhMZlM6slkTKHmKAPkeIyidvpk/Nu0x0Pajhu5U8DZuJ70CFk3vdqdQPdsZ5iLenTWPxfaYjEbfvw93FvMZ+2V6XPo46Jyz8DfafOj5a+5ds9cl7Mu8lWVtVlqEq3p7NKe6OgAo7UxWW7pyyx/Xjxj71d2lA3JFsd+Z/PJNXC28ob6Czb3L9NuZmq3sN2tuNw/z/8B6kGjCHTDlrsAAAAASUVORK5CYII=&quot;);">
											<div><span>{{$t('main.login')}}</span></div>
										</div>
										<div class="image_imageContainer image_cover login_registerBtn "
											@click="link('/register', -1)"
											style="width: 54px; cursor: inherit; background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAA4BAMAAADqVwAfAAAAHlBMVEVHcEzO3//O3//P4P/O3//Q4f/z9//3+v/v9P/R4f+V2PG9AAAABnRSTlMA44NTtSrSzaCJAAADEklEQVRIx51WvVcbMQx3gO68tvDC1jLBRt/r0o2+LrCVsWMXWYxdbBjD44m7EShw/W+rLzuXS0ISlIvvbOtn2ZIsKYRK7w6/H/xbSvcfD3+GBfT1oGtepfb+xzzqc0f4OoywfT9EfVkhSgip/TBEAdBKHMAsbqvD1SDBUfupBzsnWAtHiH+nqItnoLWkIcH1XjXYOELVYisPN5013fB0cVLMNyIAWG6upmsLGllcs1tOxihYa5ONCPDTbb0kAFwPJbBrU+Y3EQYIa2hEGCM8KmyckmxyjV2i4HKeCGr7JeaoAsEsikNeIdWibBFSujwRPd7lnHSX5LtdRjIfY85XostjRmXdp1FaCEn+z5lxDwzbz0IpRyZBxxni8SScURlSBmH+I0dTWMyLKfqSMwzXJ2HnLm9MV6dhFDeHpd3wK7+BnkSRm9NNOJoV/0pvOpJuwpmeTZUv2nLOlFTzSd/eS1Wb6TaMDZVtNik+SRMhC2f00Tov/JOwL++YyrQIkhZ0ffYKM7r2CijD7/CsAPMg85M4dTGVGqvn2Tyzt6GTjnwWcNKB/kjp+HwGuAxjSLE6rOD9ozcy9XOd52fCsDfQJJy9AYW34Qg3h9FNOG78UmugkIb7hN72Ln2d5+DxEH5JFOOwqcQ85BAGaY/7HMMb+5aWswU9hZFEdh5wYgaUeIh10FYoJIG54cC8I8GJfwq2EFrRNahib17i22nY7jSTDKLv4D1MCxzxxoVDsKisKD3v+IpYvqSR+Ho8iKYLhA5JAt6o2ZgkvG53vdVxTirNy5Wj1cM1IAZSS4vNzZqWLcTKPIh+zntLVHV1AEeptQwARAaixi3QPHp14dmceYorKYqGucQ2XmqMc7MpoXMVCSarOKeOCWcpMUYlva66L4pqd2uBoRYu4pajND3WAiNcdJJFV10yzdPY7vWKJ5NGdqnK4oA9leh9ounJXJnQYL2OrhAq9vK7J6+ZUk3KSTKTueLsproSPdnzyRYUlOiLE1RBZozprR+irOh1D5F92jYB3W0U2MwXvV5iL1fkkhJ7s4L+PylU4nMWOK1jAAAAAElFTkSuQmCC&quot;);">
											<div>{{$t('main.reg')}}</div><span></span>
										</div>
									</div>
								</div>
							</div>
							<div v-else style="display: flex;align-items: center;margin-left:40px">
								<div class="manifestList_manifestList">
									<div class="manifestList_manifest_item" @click="link('/my-center/deposit', -1)">
										<p class="manifestList_icon"></p>
										<p class="manifestList_toolName">{{$t('main.my.deposit')}}</p>
									</div>
									<div class="manifestList_manifest_item" @click="link('/my-center/transfer', -1)">
										<p class="manifestList_icon"></p>
										<p class="manifestList_toolName">{{$t('main.my.transfer')}}</p>
									</div>
									<div class="manifestList_manifest_item" @click="link('/my-center/withdrawals', -1)">
										<p class="manifestList_icon"></p>
										<p class="manifestList_toolName">{{$t('main.my.withdrawals')}}</p>
									</div>
								</div>
								<a-dropdown :class="{'dddes': dropdownShow}" @visibleChange="dropdownChange">
									<div class="userInfo_user_warp userInfo_pointer"
										@click.stop="e => e.preventDefault()">
										<div class="userInfo_userinfo">
											<div class="userInfo_username_warp">
												<p>{{userInfo.name || ''}}</p>
												<div class="image_imageContainer image_cover userInfo_vipGradImg"
													style="cursor: inherit;">
													<div @click.stop="linkXm"><img alt="vip"
															src="/assets/666xm.png"
															decoding="async"
															style="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover;">
													</div>
												</div>
											</div>
											<div class="userInfo_userinfo_bottom">
												<p style="margin-right: 5px;">${{balanceText}}</p> 
												<a-icon type="up-circle" class="downicon"  />
											</div>
										</div>
										<div class="userInfo_photo_warp"><img width="36" height="36"
												v-if="avatarImg" :src="avatarImg" alt="用户头像"
												style="cursor: pointer;"><span class="userInfo_count"></span></div>
									</div>
									<a-menu slot="overlay" style="padding: 10px;" @click="menuClick">
										<a-menu-item key="info">
											<div class="header-dwon">
												<span style="background-position: -104px 0;"></span>
												<p>{{$t('main.my.myinfo')}}</p>
											</div>
										</a-menu-item>
										<a-menu-item key="avatar">
											<div class="header-dwon">
												<span style="background-position: -104px 0;"></span>
												<p>{{$t('main.my.avate')}}</p>
											</div>
										</a-menu-item>
										<!-- <a-menu-item key="myVip">
											<div class="header-dwon">
												<span style="background-position: -182px 0;"></span>
												<p>VIP特权</p>
											</div>
										</a-menu-item> -->
										<a-menu-item key="betRecord">
											<div class="header-dwon">
												<span style="background-position: 0 0;"></span>
												<p>{{$t('main.my.tzjl')}}</p>
											</div>
										</a-menu-item>
										<a-menu-item key="transRecord">
											<div class="header-dwon">
												<span style="background-position: -156px 0;"></span>
												<p>{{$t('main.my.jyjl')}}</p>
											</div>
										</a-menu-item>
										<a-menu-item key="mail">
											<div class="header-dwon">
												<span style="background-position: -78px 0;"></span>
												<p>{{$t('main.my.xxzx')}}</p>
												 <b class="bbfff" v-if="unreadText">{{unreadText}}</b> 
											</div>
										</a-menu-item>
										<a-menu-item key="tclogin" >
											<div class="tclogin">{{$t('main.my.ologin')}}</div>
										</a-menu-item>
									</a-menu>
								</a-dropdown>

							</div>
						</div>
					</div>
				</div>
				<div class="navCard_navRightView__3irKJ"></div>
			</div>
		</div>

		<header-navs :navIndex="navActiveIndex" />

		<div class="right-page1" >
			<div class="item-it" >
				<a-tooltip placement="left">
					<template #title color="#fff">
						<span style="color: #6c7ba8;padding: 10px 10px;display: block;" @click="linkPage('/help')">{{$t('main.my.help')}}</span>
					</template>
					<div class="btn btn1" @click="linkPage('/help')"></div>
				</a-tooltip>
			</div>
			<div class="item-it">
				<a-tooltip placement="left">
					<template #title color="#fff">
						<span style="color: #6c7ba8;padding: 10px 10px;display: block;">{{$t('main.my.cs')}}</span>
					</template>
					<div class="btn btn2" @click="linkCs"></div>
				</a-tooltip>
			</div>
			<div class="item-it">
				<a-tooltip placement="left">
					<template #title color="#fff">
						<div class="lit">
							<div class="te1">
								<img :src="config.app_img" alt="">
								<p>{{$t('main.my.app')}}</p>
							</div>
							<!-- <div class="te1" style="margin-top: 15px;border-top: 1px solid #eaf3f6;padding-top: 15px;">
								<img src="" alt="">
								<p>体育APP</p>
							</div> -->
						</div>
					</template>
					<div class="btn btn3"></div>
				</a-tooltip>
			</div>
			<!-- <div class="item-it">
				<a-tooltip placement="left">
					<template #title color="#fff">
						<span style="color: #6c7ba8;padding: 10px 10px;display: block;">官方登录器</span>
					</template>
					<div class="btn btn4"></div>
				</a-tooltip>
			</div> -->
		</div>
		<div class="right-page2" v-if="rightBtn">
			<div class="item-it item-it1">
				<div class="btn btn5" @click="fhdb"></div>
			</div>
		</div>
		
		<select-avatar ref="avatar"></select-avatar>
		
		<div class="loading-app" v-if="showLoading">
			<div class="loading-box">
				<img src="/assets/loading.png" alt="">
			</div>
		</div>
		
		<a-modal :zIndex="2000" wrapClassName="bboodds" :destroyOnClose="true" title="【網站提示】" :footer="null" width="380px" centered v-model="ggModelshow">
			<div class="text-model">
				<div class="detail" style="padding: 0 25px;">
					<div class="trext" v-html="config.msg"></div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import HeaderNavs from '../HeaderNavs'
	import http from '@/http.js'
	import SelectAvatar from '../SelectAvatar.vue'
	import {
		mapActions,
		mapGetters
	} from 'vuex';
	export default {
		name: "banner",
		data() {
			return {
				navIndex: -1,
				navActiveIndex: -1,
				isShow: false,
				background1: false,
				rightBtn: false,

				name: localStorage.getItem('access_name1') || "",
				password: localStorage.getItem('access_password1') || "",
				
				showLoading: false,
				
				dropdownShow: false,
				
				ggModelshow: false
			}
		},
		computed: {
			...mapGetters(['balance', 'config', 'avatarImg', 'userInfo', 'unread']),
			
			balanceText () {
				if (this.balance) {
					if (typeof this.balance === 'number') {
						return this.balance.toFixed(2)
					} else {
						return this.balance
					}
				} else {
					return '0.00'
				}
			},
			unreadText () {
				if (this.unread >= 99) {
					return '99+'
				}
				return this.unread
			},
		},
		watch: {
			$route() {
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				if (this.$route.name == 'Home') {
					if (scrollTop > 200) {
						this.rightBtn = true;
					} else {
						this.rightBtn = false;
					}
				} else {
					this.rightBtn = true;
				}
			}
		},
		created() {
		},
		components: {
			HeaderNavs,
			SelectAvatar
		},
		activated() {
			if (localStorage.getItem('userInfo')) {
				this.getUserInfo()
			} else {
				this.setUserInfo({})
			}
			setTimeout(() => {
				if (this.config.is_alert_on === 0 && !localStorage.getItem('is_alert_on_1') && localStorage.getItem('is_login_1')) {
					localStorage.setItem('is_alert_on_1', '1')
					this.ggModelshow = true
				}
			}, 500)
		},
		mounted() {
			window.addEventListener('scroll', this.scroll);
			let scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop;
			if (this.$route.name == 'Home') {
				if (scrollTop > 200) {
					this.rightBtn = true;
				} else {
					this.rightBtn = false;
				}
			} else {
				this.rightBtn = true;
			}
			if (localStorage.getItem('userInfo')) {
				this.getUserInfo()
			} else {
				this.setUserInfo({})
			}
		},
		methods: {
			...mapActions('user', ['getUserInfo', 'setUserInfo', 'intervalGetBalance', 'setBalance', 'getUnread']),
			
			dropdownChange (type) {
				this.dropdownShow = type
			},
			linkXm ()  {
				this.$router.push({
					path: '/my-center/turnover'
				})
			},
			menuClick (data) {
				let keyLink = data.key
				if (keyLink == 'avatar') {
					this.$refs.avatar.showModel()
					return
				}
				if (keyLink == 'tclogin') {
					localStorage.removeItem('userInfo')
					localStorage.removeItem('access_token')
					localStorage.removeItem('is_alert_on_1')
					localStorage.removeItem('is_login_1')
					this.setUserInfo({})
					this.$router.push({
						path: '/login'
					})
				} else {
					this.$router.push({
						path: '/my-center/' + keyLink
					})
				}
			},
			nameCensor() {
				var regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,11}$/;
				let nameIsError = !regex.test(this.name);
				var t = this.name.charAt(0).toLowerCase();
				if (t <= "z" && t >= "a") {

				} else {
					nameIsError = true;
				}
				return nameIsError
			},
			passwordCensor() {
				var regex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
				return !regex.test(this.password)
			},
			linkLogin() {
				if (this.name == '' && this.password == '') {
					this.link('/login', -1)
					return
				}
				if (this.nameCensor()) {
					this.$message.error(this.$t('main.from.errname'));
					return
				}
				if (this.passwordCensor()) {
					this.$message.error(this.$t('main.from.errpass'));
					return
				}
				this.showLoading = true
				http({
					method: 'post',
					url: '/login',
					data: {
						// name: 'c1233215',
						// password: 'c123321',
						name: this.name,
						password: this.password,
						login_type: 1
					}
				}).then((res) => {
					if (res.code == 200) {
						localStorage.setItem('access_token', res.data.access_token)
						
						// 设置获取用户信息
						var userData = {
							...res.data,
							name: res.data.user ? res.data.user.name : ''
						}
						localStorage.setItem('userInfo', JSON.stringify(userData))
						this.setUserInfo(userData)
						this.getUserInfo()
						
						this.showLoading = false
						
						// 获取钱包
						this.setBalance()
						this.intervalGetBalance()
						this.getUnread()
						
						this.$message.success(this.$t('main.message.loginSucc'));
						
						localStorage.setItem('is_login_1', '1')
						setTimeout(() => {
							if (this.config.is_alert_on === 0 && !localStorage.getItem('is_alert_on_1') && localStorage.getItem('is_login_1')) {
								localStorage.setItem('is_alert_on_1', '1')
								this.ggModelshow = true
							}
						}, 500)
					} else {
						this.showLoading = false
						this.$message.error(res.message);
					}
				})
			},
			scroll() {
				let scrollTop =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop;
				if (scrollTop > 50) {
					this.background1 = true;
				} else {
					this.background1 = false;
				}
				if (this.$route.name == 'Home') {
					if (scrollTop > 200) {
						this.rightBtn = true;
					} else {
						this.rightBtn = false;
					}
				} else {
					this.rightBtn = true;
				}
			},
			linkPage (url) {
				window.scrollTo(0, 0)
				this.$router.push({
					path: url
				})
			},
			linkCs () {
				window.open(this.config.service_link)
			},
			link(url, index) {
				window.scrollTo(0, 0)
				this.$router.push({
					path: url
				})
				this.navIndex = index
				this.navActiveIndex = -1
			},
			register() {
				this.$router.push({
					path: '/register'
				})
			},
			fhdb() {
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
	.dddssa {
		// margin-right: 44px;
		    font-size: 14px;
		    display: flex;
		    align-items: center;
		    height: 100%;
	}
	.bbfff {
		    display: inline-block;
		    height: 16px;
		    margin-left: 6px;
		    border-radius: 10px;
		    font-size: 12px;
		    line-height: 16.5px;
		    background-color: red;
		    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3);
		    padding: 0 6px;
		    color: #fff;
		    font-weight: normal;
	}
	.loading-app {
		background: rgba(0, 0, 0, .5);
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1300;
		overflow: hidden;
	}
	
	.loading-app div {
		height: 96px;
		width: 96px;
		position: relative;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}
	
	.loading-app div img {
		height: 96px;
		width: 96px;
		display: block;
	}
	
	.tclogin {
		width: 100%;
		    outline: none;
		    border: 1px solid #e2e7ef;
		    font-size: 14px;
		    color: #cbced8;
		    background-color: #fff;
		    padding: 11px 0;
		    -webkit-transition: all .2s ease-out;
		    transition: all .2s ease-out;
		    border-radius: 4px;
		    cursor: pointer;
			margin: 0 auto;
			text-align: center;
			&:hover {
				    border: 1px solid #4176fa;
				    color: #4176fa;
			}
	}
	.header-dwon {
		height: 49px;
		display: flex;
		align-items: center;

		&:hover {
			p {
				color: #4176fa;
			}
		}

		span {
			width: 24px;
			height: 24px;
			// background-image: url(../../assets/header/sprite.png);
			background-image: url(/assets/header/sprite.png);
			background-size: 232px 24px;
			background-repeat: no-repeat;
		}

		p {
			font-size: 14px;
			font-weight: 400;
			color: #414655;
			padding: 3px 0;
			margin-left: 12px;
			text-align: left;
		}
	}

	.userInfo_user_warp {
		cursor: pointer;
		display: flex;

		.userInfo_userinfo {
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-flex-direction: column;
			flex-direction: column;

			.userInfo_username_warp {
				display: -webkit-flex;
				display: flex;
				-webkit-align-items: center;
				align-items: center;
				height: 16px;

				&>p {
					font-size: 16px;
					color: #6c7ba8;
					-webkit-transition: color .2s ease-out;
					transition: color .2s ease-out;
					text-overflow: ellipsis;
					max-width: 106px;
					word-break: normal;
					overflow: hidden;
				}

				.image_imageContainer {
					display: inline-block;
					width: 40px;
					height: 16px;
					vertical-align: middle;
					margin-left: 10px;
					position: relative;
					background-size: cover;
				}
			}

			.userInfo_userinfo_bottom {
				display: -webkit-flex;
				display: flex;
				height: 20px;
				-webkit-align-items: center;
				align-items: center;
				margin-top: 4px;

				&>p {
					font-size: 16px;
					color: #6c7ba8;
					-webkit-transition: color .2s ease-out;
					transition: color .2s ease-out;
					text-overflow: ellipsis;
					max-width: 106px;
					word-break: normal;
					overflow: hidden;
				}
				i {
					color: #6c7ba8;
				}
			}
		}

		.userInfo_photo_warp {
			width: 48px;
			height: 48px;
			border-radius: 50%;
			position: relative;
			margin-left: 16px;
			// background-color: #fff;
			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
	}

	.manifestList_manifestList {
		width: 128px;
		height: 24px;
		padding: 0 16px 2px;
		border-radius: 12px;
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-align-items: center;
		align-items: center;
		margin-right: 16px;

		.manifestList_manifest_item {
			cursor: pointer;
			color: #fff;
			font-size: 12px;
			white-space: nowrap;
			margin-right: 20px;
			text-align: center;

			&:hover {
				&:nth-child(1) {
					.manifestList_icon {
						// background-image: url(../../assets/header/icon_hover_01.png);
						background-image: url(/assets/header/icon_hover_01.png);
					}
				}

				&:nth-child(2) {
					.manifestList_icon {
						// background-image: url(../../assets/header/icon_hover_02.png);
						background-image: url(/assets/header/icon_hover_02.png);
					}
				}

				&:nth-child(3) {
					.manifestList_icon {
						// background-image: url(../../assets/header/icon_hover_03.png);
						background-image: url(/assets/header/icon_hover_03.png);
					}
				}
			}

			&:nth-child(1) {
				.manifestList_icon {
					background-image: url(data:image/png;base64,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);
				}
			}

			&:nth-child(2) {
				.manifestList_icon {
					background-image: url(data:image/png;base64,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);
				}
			}

			&:nth-child(3) {
				.manifestList_icon {
					background-image: url(data:image/png;base64,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);
				}
			}

			.manifestList_icon {
				width: 36px;
				height: 36px;
				margin: 0 auto;
				background-size: cover;
			}

			.manifestList_toolName {
				color: #6c7ba8;
				line-height: 20px;
				font-size: 14px;
			}
		}
	}

	.lit {
		padding: 12px 16px;
		color: rgba(0, 0, 0, .85);

		img {
			width: 80px;
			height: 80px;
			margin: 3px 0 7px;
			display: block;
			background-color: red;
		}

		p {
			text-align: center;
		}
	}

	.right-page1 {
		position: fixed;
		z-index: 98;
		top: 50%;
		right: 6px;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		width: 56px;

		.item-it {
			margin-bottom: 10px;

			.btn {
				width: 56px;
				cursor: pointer;
				height: 56px;
				background-size: cover;
				border-radius: 50%;
				box-shadow: 5px 6px 10px 0 rgba(180, 194, 227, .5);
			}

			.btn1 {
				// background-image: url(../../assets/right/btn.8986f99459532c8eaad78cb5a20f829e.png);
				background-image: url(/assets/right/btn.8986f99459532c8eaad78cb5a20f829e.png);
			}

			.btn2 {
				// background-image: url(../../assets/right/service-041fbf239963e5c2134894a7355c6982.png);
				background-image: url(/assets/right/service-041fbf239963e5c2134894a7355c6982.png);
			}

			.btn3 {
				// background-image: url(../../assets/right/appdown-77d5de3e8ad26f57a0481786d0789d18.png);
				background-image: url(/assets/right/appdown-77d5de3e8ad26f57a0481786d0789d18.png);
			}

			.btn4 {
				// background-image: url(../../assets/right/weblogin-a724907cf7a3e87ffaf2f2520a4d47d0.png);
				background-image: url(/assets/right/weblogin-a724907cf7a3e87ffaf2f2520a4d47d0.png);
			}

			.btn5 {
				// background-image: url(../../assets/right/top-d019fc79a7ccee746e61995cc83326fc.png);
				background-image: url(/assets/right/top-d019fc79a7ccee746e61995cc83326fc.png);
				border-radius: 6px;
				box-shadow: 0 4px 6px 0 rgba(184, 208, 255, .3);
				margin-top: 60px;

			}
		}
	}

	.right-page2 {
		position: fixed;
		right: 6px;
		bottom: 20px;
		width: 56px;

		.item-it {
			margin-bottom: 10px;

			.btn {
				width: 56px;
				cursor: pointer;
				height: 56px;
				background-size: cover;
				border-radius: 50%;
				box-shadow: 5px 6px 10px 0 rgba(180, 194, 227, .5);
			}

			.btn1 {
				// background-image: url(../../assets/right/btn.8986f99459532c8eaad78cb5a20f829e.png);
				background-image: url(/assets/right/btn.8986f99459532c8eaad78cb5a20f829e.png);
			}

			.btn2 {
				// background-image: url(../../assets/right/service-041fbf239963e5c2134894a7355c6982.png);
				background-image: url(/assets/right/service-041fbf239963e5c2134894a7355c6982.png)
			}

			.btn3 {
				// background-image: url(../../assets/right/appdown-77d5de3e8ad26f57a0481786d0789d18.png);
				background-image: url(/assets/right/appdown-77d5de3e8ad26f57a0481786d0789d18.png);
			}

			.btn4 {
				// background-image: url(../../assets/right/weblogin-a724907cf7a3e87ffaf2f2520a4d47d0.png);
				background-image: url(/assets/right/weblogin-a724907cf7a3e87ffaf2f2520a4d47d0.png);
			}

			.btn5 {
				// background-image: url(../../assets/right/top-d019fc79a7ccee746e61995cc83326fc.png);
				background-image: url(/assets/right/top-d019fc79a7ccee746e61995cc83326fc.png);
				border-radius: 6px;
				box-shadow: 0 4px 6px 0 rgba(184, 208, 255, .3);
				margin-top: 60px;

			}
		}
	}

	.header-page {
		height: 90px;
		z-index: 1112;
		z-index: 999;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		-webkit-transition: background-image 0.5s ease, background-color 0.3s ease;
		transition: background-image 0.5s ease, background-color 0.3s ease;
		background-image: -webkit-gradient(linear,
				left top,
				left bottom,
				from(#7f8ea8),
				color-stop(28%, rgba(115, 120, 157, 0.65)),
				color-stop(93%, rgba(157, 166, 185, 0)),
				color-stop(138%, rgba(171, 178, 193, 0)));
		background-image: -webkit-linear-gradient(top,
				#7f8ea8,
				rgba(115, 120, 157, 0.65) 28%,
				rgba(157, 166, 185, 0) 93%,
				rgba(171, 178, 193, 0) 138%);
		background-image: linear-gradient(to bottom,
				#7f8ea8,
				rgba(115, 120, 157, 0.65) 28%,
				rgba(157, 166, 185, 0) 93%,
				rgba(171, 178, 193, 0) 138%);
		background-image: -webkit-gradient(linear,
				left top,
				left bottom,
				from(#8d9ea9),
				color-stop(80%, rgba(192, 208, 219, 0)));
		background-image: -webkit-linear-gradient(top,
				#8d9ea9 0%,
				rgba(192, 208, 219, 0) 80%);
		background-image: linear-gradient(to bottom,
				#8d9ea9 0%,
				rgba(192, 208, 219, 0) 80%);
		-webkit-box-shadow: none;
		box-shadow: none;

		&.background1 {
			background-image: none !important;
			background-color: #fff !important;
		}

		.manifestList_manifestList__2aFfv {
			width: 128px;
			height: 24px;
			padding: 0 16px 2px;
			border-radius: 12px;
			background-color: #6c7ba8;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-align-items: center;
			align-items: center;
			margin-right: 16px
		}

		.manifestList_manifestList__2aFfv .manifestList_manifest_item__3OhyX {
			cursor: pointer;
			color: #fff;
			font-size: 12px;
			white-space: nowrap
		}

		.manifestList_manifestList__2aFfv .manifestList_manifest_item__3OhyX:nth-child(2) {
			margin: 0 12px
		}

		.manifestList_manifestList__2aFfv .manifestList_manifest_item__3OhyX:hover {
			opacity: .8
		}

		.manifestList_manifestList__2aFfv .manifestList_line__2_zev {
			-webkit-flex: 0 0 1px;
			flex: 0 0 1px;
			height: 37px;
			margin: 0 12px;
			background-color: #ced2e2;
			opacity: .3
		}

		.inputItem_inputItemView {
			width: 256px;
			height: 40px;
			border-radius: 4px;
			line-height: 20px;
			color: #414655;
			border: 1px solid #e4eaff !important
		}

		.inputItem_inputItemView:focus,
		.inputItem_inputItemView:hover {
			outline: none;
			box-shadow: none;
			border: 1px solid #4176fa
		}

		.inputItem_inputItemView.inputItem_disabledText__2GtcW {
			background-color: initial !important;
			border-color: transparent !important;
			pointer-events: none;
			padding-left: 0;
			box-shadow: none !important;
			color: #cbced8
		}

		.inputItem_inputItemView .inputItem_rightIcon__3wqwk {
			width: 16px;
			height: auto;
			cursor: pointer
		}

		.inputItem_inputItemView input::-webkit-input-placeholder,
		.inputItem_inputItemView input:placeholder-shown {
			font-size: 14px;
			color: #cbced8
		}

		.inputItem_inputItemView::-webkit-input-placeholder {
			font-size: 14px;
			color: #cbced8
		}

		.inputItem_inputItemView:-moz-placeholder,
		.inputItem_inputItemView::-moz-placeholder {
			font-size: 14px;
			color: #cbced8
		}

		.inputItem_inputItemView:-ms-input-placeholder {
			font-size: 14px;
			color: #cbced8
		}

		.login_loginStyle__3Dw8g {
			display: -webkit-flex;
			display: flex;
			width: 421px
		}

		.login_loginStyle__3Dw8g input[type=password],
		.login_loginStyle__3Dw8g input[type=text] {
			width: 130px;
			height: 24px;
			border-radius: 12px;
			background-color: rgba(0, 0, 0, .18);
			border: none
		}

		.login_userInfo {
			color: hsla(0, 0%, 100%, .8);
			line-height: 1.8;
			text-align: center
		}

		.login_userInfo,
		.login_userInfo .login_loginBtn {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			font-size: 14px
		}

		.login_userInfo .login_loginBtn {
			margin-left: 4px;
			-webkit-justify-content: center;
			justify-content: center;
			background-size: cover;
			color: #fff;
			border-radius: 25px;
			opacity: 1;
			-webkit-transition: all .3s;
			transition: all .3s;
			z-index: 999
		}

		.login_userInfo .login_loginBtn,
		.login_userInfo .login_loginBtn div {
			width: 54px;
			height: 28px;
			line-height: 28px;
			cursor: pointer
		}

		.login_userInfo .login_loginBtn:hover {
			opacity: .8
		}

		.login_userInfo .login_registerBtn {
			background-size: cover;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: center;
			justify-content: center;
			font-size: 14px;
			margin-left: 4px;
			color: #6c7ba8;
			border-radius: 25px;
			opacity: 1;
			-webkit-transition: all .3s;
			transition: all .3s;
			box-shadow: 0 4px 8px 0 rgba(194, 211, 222, .67), inset 0 1px 7px 0 #fff, inset 0 -3px 4px 0 rgba(175, 194, 230, .16)
		}

		.login_userInfo .login_registerBtn,
		.login_userInfo .login_registerBtn div {
			width: 54px;
			height: 28px;
			line-height: 28px;
			cursor: pointer
		}

		.login_userInfo .login_registerBtn:hover {
			opacity: .8
		}

		.login_userInfo input::placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_userInfo input::-webkit-input-placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_userInfo input::-moz-input-placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_userInfo input:-webkit-autofill {
			-webkit-transition-delay: 99999s;
			transition-delay: 99999s;
			-webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
			transition: color 99999s ease-out, background-color 99999s ease-out;
			box-shadow: inset 0 0 0 100px rgba(108, 123, 168, .5) !important;
			outline: none
		}

		.login_userInfo input:-webkit-autofill:active,
		.login_userInfo input:-webkit-autofill:focus,
		.login_userInfo input:-webkit-autofill:hover {
			-webkit-transition-delay: 99999s;
			transition-delay: 99999s;
			-webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
			transition: color 99999s ease-out, background-color 99999s ease-out;
			box-shadow: inset 0 0 0 100px rgba(108, 123, 168, .8) !important
		}

		.login_inputbox {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			padding: 0 12px;
			margin: 0 5px;
			width: 104px;
			height: 28px;
			border-radius: 14px;
			background-color: rgba(108, 123, 168, .5);
			border: none;
			color: #fff
		}

		.login_inputbox:active,
		.login_inputbox:focus,
		.login_inputbox:hover {
			background-color: rgba(108, 123, 168, .8);
			border: none
		}

		.login_inputbox::placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_inputbox::-webkit-input-placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_inputbox::-moz-input-placeholder {
			color: #fff;
			font-size: 12px;
			opacity: .8
		}

		.login_pwdBox__3rNpO {
			position: relative
		}

		.login_pwdBox__3rNpO .login_inputbox {
			padding: 0 50px 0 12px
		}

		.login_validInputContainer__Ik35q {
			width: 104px;
			height: 28px;
			position: relative
		}

		.login_validInputContainer__Ik35q .login_validInput__3-Hp5 {
			margin: 0;
			padding: 0 55px 0 12px
		}

		.login_validInputContainer__Ik35q .login_validateCode__3giHa {
			width: 50px;
			height: 24px;
			position: absolute;
			cursor: pointer;
			right: 2px;
			top: 2px;
			border-radius: 12px;
			overflow: hidden
		}

		.login_validInputContainer__Ik35q .login_validateCode__3giHa img {
			width: 100%;
			height: 100%;
			vertical-align: top
		}

		.login_forgetstyle__214Xm {
			position: absolute;
			right: 7px;
			top: 0;
			line-height: 28px;
			cursor: pointer;
			color: hsla(0, 0%, 100%, .8);
			font-size: 12px
		}

		.login_forgetstyle__214Xm:hover {
			color: #fff
		}

		.navIcon_unReadDot__1GvkN {
			position: relative;
			top: -4px;
			margin-left: 5px;
			width: 6px;
			height: 6px;
			background-color: #db6372;
			border-radius: 50%
		}

		.navIcon_mailNum__yeOSE {
			position: absolute;
			right: 28px;
			top: 16px;
			min-width: 16px;
			height: 16px;
			text-align: center;
			border-radius: 8px;
			padding: 0 5px;
			font-size: 12px;
			line-height: 16px;
			color: #fff;
			background-image: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background-image: linear-gradient(90deg, #62b3ff, #3d72fa)
		}

		.userInfo_user_warp {
			display: -webkit-flex;
			display: flex
		}

		.userInfo_user_warp.userInfo_pointer__2Inz7 {
			cursor: pointer
		}
		.downicon {
			transition: all 0.3s;
		}
		.dddes .downicon {
			transform: rotate(180deg);
		}

		.userInfo_user_warp .userInfo_logout_box__2Hrph {
			display: -webkit-flex;
			display: flex
		}

		.userInfo_user_warp .userInfo_photo_warp__O4AR- {
			width: 48px;
			height: 48px;
			border-radius: 50%;
			position: relative;
			margin-left: 16px
		}

		.userInfo_user_warp .userInfo_photo_warp__O4AR- .userInfo_count__7vyhz {
			position: absolute;
			top: 0;
			right: 0;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			border: 1px solid #fff;
			background-color: #db6372
		}

		.userInfo_user_warp .userInfo_photo_warp__O4AR- img {
			width: 100%;
			height: 100%;
			border-radius: 50%
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_username_warp__1fRe- {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			height: 16px
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_username_warp__1fRe- p {
			font-family: DinPro
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC p {
			font-size: 16px;
			color: #6c7ba8;
			-webkit-transition: color .2s ease-out;
			transition: color .2s ease-out
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_userinfo_bottom__3q-g7 {
			display: -webkit-flex;
			display: flex;
			height: 20px;
			-webkit-align-items: center;
			align-items: center;
			margin-top: 4px
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_userinfo_bottom__3q-g7 p {
			font-family: DINPro-Medium !important
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_userinfo_bottom__3q-g7 img {
			width: 14px;
			height: 14px;
			margin-left: 8px;
			-webkit-transition: all .3s ease;
			transition: all .3s ease;
			margin-top: 1px
		}

		.userInfo_user_warp .userInfo_userinfo__14MxC .userInfo_userinfo_bottom__3q-g7 .userInfo_arrowRotate__1vLtc {
			-webkit-transform: rotate(-180deg);
			transform: rotate(-180deg)
		}

		.userInfo_user_warp .userInfo_login_wrap__aAwkB {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			margin-left: 12px;
			font-size: 14px;
			color: #67718f
		}

		.userInfo_user_warp .userInfo_login_wrap__aAwkB .userInfo_text__ZL0fC {
			-webkit-transition: all .2s ease;
			transition: all .2s ease;
			cursor: pointer
		}

		.userInfo_user_warp .userInfo_login_wrap__aAwkB .userInfo_text__ZL0fC:hover {
			color: #6aaaf5
		}

		.userInfo_default_cursor {
			cursor: default
		}

		.userInfo_default_cursor:hover p {
			color: #67718f
		}

		.userInfo_vipGradImg__2InSI {
			display: inline-block;
			width: 40px;
			height: 16px;
			vertical-align: middle;
			margin-left: 10px;
			cursor: pointer
		}

		.userSuspension_user_suspension_wrap__2aoBr {
			width: 200px;
			border-radius: 4px;
			padding: 14px;
			box-sizing: border-box
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_suspension_nav__3pS5X {
			margin-bottom: 20px
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI {
			width: 100%
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 {
			cursor: pointer;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			position: relative
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8:first-child .userSuspension_title__1W_1D {
			padding-top: 0 !important
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D {
			width: 100%;
			padding: 14px 0;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: flex-start;
			justify-content: flex-start
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_item_icon__WnqBr {
			width: 24px;
			height: 24px;
			// background-image: url(/_next/static/media/sprite.c2b608799948eef0236ef16d4d91084e.png);
			background-size: 232px 24px;
			background-repeat: no-repeat;
			margin-bottom: 8px
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_red_lot__3KOJS {
			position: relative;
			background-color: #db6372;
			border-radius: 50%;
			margin-left: 3px;
			top: -7px;
			width: 6px;
			height: 6px;
			display: block
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_personal__pLiWT {
			background-position: -104px 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_vip__2m-AP {
			background-position: -182px 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_betRecord__9FoF2 {
			background-position: 0 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_transRecord__22Vw6 {
			background-position: -156px 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_ybMall__1twl_ {
			background-position: -208px 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D .userSuspension_mail__33Jlm {
			background-position: -78px 0
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D h1 {
			font-size: 14px;
			font-weight: 400;
			color: #414655;
			padding: 3px 0;
			margin-left: 12px;
			text-align: left
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_title__1W_1D:hover h1 {
			color: #4176fa
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_user_info_navlist__30ykI .userSuspension_item__2xrC8 .userSuspension_count__1UovU {
			position: absolute;
			right: 28px;
			top: 18px;
			min-width: 16px;
			height: 16px;
			text-align: center;
			border-radius: 8px;
			padding: 0 5px;
			font-size: 12px;
			line-height: 16px;
			color: #fff;
			background-image: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background-image: linear-gradient(90deg, #62b3ff, #3d72fa)
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_logout_btn__1hEXX {
			width: 100%;
			text-align: center;
			margin-top: 8px;
			overflow: hidden
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_logout_btn__1hEXX button {
			width: 100%;
			outline: none;
			border: 1px solid #e2e7ef;
			font-size: 14px;
			color: #cbced8;
			background-color: #fff;
			padding: 11px 0;
			-webkit-transition: all .2s ease-out;
			transition: all .2s ease-out;
			border-radius: 4px;
			cursor: pointer
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_logout_btn__1hEXX button:hover {
			border: 1px solid #4176fa;
			color: #4176fa
		}

		.userSuspension_user_suspension_wrap__2aoBr .userSuspension_logout_btn__1hEXX button:active {
			box-shadow: 0 0 0 4px #fffaf5
		}

		.userSuspension_yb-popover__SZ7FF {
			left: 0 !important
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_modal__3WuUU {
			padding: 23px 0 16px;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: center;
			justify-content: center
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_modal__3WuUU .logOutPop_qrcode_box__2LPZB:not(:first-child) {
			margin-left: 70px
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_modal__3WuUU .logOutPop_qrcode_box__2LPZB .logOutPop_qrcode_border__CaBod {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: center;
			justify-content: center;
			background-size: cover;
			background-position: 50%;
			background-repeat: no-repeat
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_modal__3WuUU .logOutPop_qrcode_box__2LPZB p {
			text-align: center;
			color: #a5a9b3;
			font-size: 12px;
			line-height: 18px
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_modal__3WuUU .logOutPop_qrcode_box__2LPZB p:not(:last-child) {
			margin-top: 8px
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_btn__3aT2i {
			border-top: 1px solid #ebedf0;
			text-align: left;
			color: #676b77;
			padding: 16px 0 18px 48px
		}

		.logOutPop_download_wrap__3B5qc .logOutPop_download_qrcode_btn__3aT2i :hover {
			color: #4176fa
		}

		.navLink_navLinkView {
			position: relative;
			width: 56px;
			padding-right: 24px;
			height: 100%;
			line-height: 90px;
			color: #6c7ba8;
			cursor: pointer;
			-webkit-transition: all .2s ease;
			transition: all .2s ease
		}

		.navLink_navLinkView .navLink_nameText {
			position: relative;
			width: 100%;
			text-align: center;
			font-size: 14px;
			line-height: 90px
		}

		.navLink_navLinkView .navLink_nameText:after {
			content: "";
			display: block;
			position: absolute;
			width: 0;
			height: 2px;
			background: #4176fa;
			border-radius: 1px;
			bottom: 24px;
			left: 50%;
			-webkit-transition: all .2s;
			transition: all .2s
		}

		.navLink_navLinkView.navLink_isLastView__2EmSg {
			margin-right: 76px
		}

		.navLink_navLinkView.navLink_isLoginView {
			margin-right: 26px
		}

		.navLink_navLinkView.navLink_isVerifyView__225r8 {
			margin-right: 0
		}

		.navLink_navLinkView.navLink_isActiveView,
		.navLink_navLinkView:hover {
			color: #3181ff
		}

		.navLink_navLinkView.navLink_isActiveView .navLink_nameText:after,
		.navLink_navLinkView:hover .navLink_nameText:after {
			left: 0;
			width: 100%
		}

		.iconLink_iconLinkView {
			position: relative;
			width: 48px;
			height: 90px;
			padding-right: 20px;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
			-webkit-align-items: center;
			align-items: center;
			color: #6c7ba8;
			cursor: pointer;
			-webkit-transition: all .2s ease;
			transition: all .2s ease
		}

		.iconLink_iconLinkView:last-child {
			width: 28px;
			padding-right: 0
		}

		.iconLink_iconLinkView .iconLink_navbarIcon {
			margin-top: 21px;
			width: 28px;
			height: auto
		}

		.iconLink_iconLinkView .iconLink_navbarName {
			line-height: 20px
		}

		.iconLink_iconLinkView:hover {
			opacity: .8
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS {
			width: 100%;
			padding: 16px 20px;
			box-sizing: border-box
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_containerTitle__18STK {
			font-family: PingFang SC;
			font-size: 18px;
			font-style: normal;
			font-weight: 700;
			line-height: 25px;
			letter-spacing: 0;
			text-align: center;
			margin-bottom: 8px;
			color: #3e4a70
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_container_desc__3JOx6 span {
			display: block;
			line-height: 18px;
			font-size: 14px;
			color: #9aa4c2;
			font-weight: 400;
			margin-bottom: 4px
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_containerText__2KdJr {
			margin-top: 12px;
			margin-bottom: 4px;
			font-size: 14px;
			color: #9aa4c2
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_iconSection__2BsTr {
			width: 100%;
			height: 100%;
			position: relative;
			border-radius: 8px
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_iconSection__2BsTr .memoryDomainModal_siteBg__1x-8x {
			width: 100%;
			height: 62px;
			// background-image: url(/_next/static/media/img_signoff_logo.c07a55a8a0e7533ab3708e8d0d9e927b.png);
			background-repeat: no-repeat;
			background-position: 50%;
			background-size: 100% 100%
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_iconSection__2BsTr .memoryDomainModal_setFavorBg__3lxX8 {
			width: 100%;
			height: 113px;
			// background-image: url(/_next/static/media/img_signoff_collect.e4e140aaef46e7fe7e12db8ea278f60a.png);
			background-repeat: no-repeat;
			background-position: 50%;
			background-size: 100% 100%
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro {
			width: 100%;
			min-height: auto;
			max-height: auto;
			padding: 8px 0;
			border-radius: 8px;
			background-color: #f7f7f7;
			overflow: auto;
			overflow-y: scroll
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_officeTitle__33BGg {
			color: #9aa4c2;
			height: 20px;
			line-height: 20px;
			display: block;
			width: 368px;
			margin: 0 auto
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_officeTitle__33BGg.memoryDomainModal_vipTitle__1adP1 {
			margin-top: 4px;
			color: #4176fa
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_officeTitle__33BGg.memoryDomainModal_vipTitle__1adP1 i {
			background: #4176fa
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_officeTitle__33BGg i {
			width: 4px;
			height: 4px;
			border-radius: 2px;
			margin: 0 4px 2px 2px;
			display: inline-block;
			background: #6c7ba8
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			text-align: center;
			position: relative;
			width: 368px;
			min-height: 24px;
			padding: 0 10px 0 25px;
			background: #fff;
			border: .5px solid #cbced8;
			border-radius: 15px;
			font-size: 14px;
			color: #9aa4c2;
			margin: 4px auto
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc.memoryDomainModal_vipItem__2WhIB {
			color: #4176fa;
			border: .5px solid #4176fa
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc.memoryDomainModal_vipItem__2WhIB:before {
			// background-image: url(/_next/static/media/ico_search_theme.3effea910a544cff0e31ca161335aadb.png);
			background-size: contain
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc span {
			font-family: DIN Pro;
			font-style: normal;
			font-weight: 400;
			font-size: 12px;
			width: 100%;
			min-height: 24px;
			line-height: 24px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			cursor: pointer
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc span:hover {
			text-decoration: underline
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc:last-child {
			margin-bottom: 0
		}

		.memoryDomainModal_memoryDomainModalContainer__2IaXS .memoryDomainModal_domainSection__nexro .memoryDomainModal_domainItem__1NCSc:before {
			content: "";
			position: absolute;
			top: 50%;
			left: 10px;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
			width: 13px;
			height: 13px;
			// background-image: url(/_next/static/media/ico_search_gray.b9092426330600e075ecaeedc8d792cb.png);
			background-size: contain
		}

		.memoryDomainModal_modalDomainView__QzC6- .memoryDomainModal_headerView__2wvPh {
			background-image: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background-image: linear-gradient(90deg, #62b3ff, #3d72fa);
			border-radius: 8px 8px 0 0
		}

		@-webkit-keyframes memoryDomainModal_zoomIn__CFlC1 {
			0% {
				opacity: 0;
				-webkit-transform: translate3d(-10%, -64%, 0) scale(.3);
				transform: translate3d(-10%, -64%, 0) scale(.3)
			}

			to {
				opacity: 1;
				-webkit-transform: translateZ(0) scale(1);
				transform: translateZ(0) scale(1)
			}
		}

		@keyframes memoryDomainModal_zoomIn__CFlC1 {
			0% {
				opacity: 0;
				-webkit-transform: translate3d(-10%, -64%, 0) scale(.3);
				transform: translate3d(-10%, -64%, 0) scale(.3)
			}

			to {
				opacity: 1;
				-webkit-transform: translateZ(0) scale(1);
				transform: translateZ(0) scale(1)
			}
		}

		.memoryDomainModal_zoomIn__CFlC1 {
			-webkit-animation: memoryDomainModal_zoomIn__CFlC1 .3s ease;
			animation: memoryDomainModal_zoomIn__CFlC1 .3s ease
		}

		@-webkit-keyframes memoryDomainModal_zoomOut__2_ngB {
			0% {
				opacity: 1;
				-webkit-transform: translate3d(0, 40%, 0) scale(1);
				transform: translate3d(0, 40%, 0) scale(1);
				background: #fff
			}

			to {
				opacity: 0;
				-webkit-transform: translate3d(-30px, -156px, 0) scale(.1);
				transform: translate3d(-30px, -156px, 0) scale(.1);
				background: #fff
			}
		}

		@keyframes memoryDomainModal_zoomOut__2_ngB {
			0% {
				opacity: 1;
				-webkit-transform: translate3d(0, 40%, 0) scale(1);
				transform: translate3d(0, 40%, 0) scale(1);
				background: #fff
			}

			to {
				opacity: 0;
				-webkit-transform: translate3d(-30px, -156px, 0) scale(.1);
				transform: translate3d(-30px, -156px, 0) scale(.1);
				background: #fff
			}
		}

		.memoryDomainModal_zoomOut__2_ngB {
			-webkit-animation: memoryDomainModal_zoomOut__2_ngB .4s ease;
			animation: memoryDomainModal_zoomOut__2_ngB .4s ease
		}

		.Input_Input__2gYb7 {
			border-radius: 6px;
			border: 1px solid #ebedf0;
			border-radius: 4px;
			padding: 0 0 0 12px;
			background-color: #fff;
			color: #414755;
			color: #666
		}

		.Input_Input__2gYb7::-webkit-input-placeholder {
			color: #94a6b7 !important;
			font-size: 14px;
			font-weight: 400 !important
		}

		.Input_Input__2gYb7:hover {
			-webkit-transition: all .3s ease;
			transition: all .3s ease;
			border-color: #4176fa
		}

		.Input_Input__2gYb7:focus {
			-webkit-transition: background-color .2s ease, border .2s ease;
			transition: background-color .2s ease, border .2s ease;
			border-color: #4176fa
		}

		.Input_Input__2gYb7:-webkit-autofill {
			-webkit-transition: background-color 5000s ease-in-out 0s;
			transition: background-color 5000s ease-in-out 0s;
			-webkit-text-fill-color: transparent !important
		}

		.Input_Input__2gYb7::-webkit-inner-spin-button,
		.Input_Input__2gYb7::-webkit-outer-spin-button {
			-webkit-appearance: none
		}

		.Input_Input__2gYb7[type=number] {
			-moz-appearance: textfield
		}

		.Input_disabled__2htBh {
			background-color: rgba(216, 220, 231, .2);
			pointer-events: none
		}

		.transferModal_transMoneyModalMain__33yC8 {
			padding: 24px 24px 30px
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg {
			position: relative;
			padding: 0 25px;
			margin: 20px 0 10px !important;
			height: auto
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR {
			width: 320px;
			margin: 0 auto !important;
			padding: 0
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_title__xL6_C {
			min-height: 40px;
			margin: 0 0 12px !important;
			line-height: normal;
			font-family: PingFangSC;
			font-size: 14px;
			text-align: justify;
			color: #414755
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR span {
			font-family: DINPro;
			font-size: 14px;
			line-height: normal;
			color: #4176fa
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_transMoneyTodo__1cKMR {
			margin-top: 12px !important
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_transMoneyTodo__1cKMR input {
			width: 320px !important;
			height: 40px !important;
			padding: 0 55px 0 12px;
			border-radius: 4px;
			border: 1px solid #e4eaff;
			background-color: initial
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_transMoneyTodo__1cKMR input:focus {
			border-color: #4176fa
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_transMoneyTodo__1cKMR button {
			color: #4176fa;
			position: absolute !important;
			right: 0;
			box-shadow: none !important;
			background: transparent !important
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg.transferModal_ayx__V_3rR .transferModal_transMoneyTodo__1cKMR button:hover {
			background: transparent !important
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg .transferModal_error__Dxpn- {
			color: red;
			text-align: center !important;
			margin-top: 6px !important
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg P {
			text-align: left
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg p.transferModal_moneyTitle__1d69n {
			color: #414655
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg span {
			display: inline-block;
			height: auto;
			vertical-align: bottom;
			line-height: 20px
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg span.transferModal_centerMoneys__3zsme {
			display: block;
			color: #414655;
			text-align: left
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg .transferModal_transMoneyTodo__1cKMR {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			margin-top: 10px
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg p.transferModal_moneyTip__2qH_Y {
			margin-top: 6px;
			color: red
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg .transferModal_footerButton__1CuRM {
			padding-top: 30px;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			margin-bottom: 30px
		}

		.transferModal_transMoneyModalMain__33yC8 .transferModal_vipTransMoneyModal__2cwlg .transferModal_footerButton__1CuRM .transferModal_footerBtn__16Y5P {
			border: 1px solid #4176fa;
			width: 148px
		}

		.transferModal_footerBtn__16Y5P {
			border: 1px solid #4176fa
		}

		.transferModal_YbModal__26Uh2 {
			position: relative;
			top: 50%;
			-webkit-transform: translateY(calc(-50% - .5px));
			transform: translateY(calc(-50% - .5px));
			margin: 0 auto
		}

		.transferModal_okBtn__1-2aD {
			background-image: -webkit-linear-gradient(right, #79aafe, #4176fa 100%) !important;
			background-image: linear-gradient(270deg, #79aafe, #4176fa) !important
		}

		.navCard_navCardView__3IWZV {
			width: 100%;
			height: 90px;
			position: fixed;
			z-index: 100
		}

		.navCard_navCardView__3IWZV .navCard_navBg__1z0Q_ {
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			opacity: .4;
			background-image: -webkit-linear-gradient(top, rgba(103, 133, 180, .68), rgba(103, 133, 180, 0), rgba(103, 133, 180, 0) 200%);
			background-image: linear-gradient(180deg, rgba(103, 133, 180, .68), rgba(103, 133, 180, 0), rgba(103, 133, 180, 0) 200%)
		}

		.navCard_navCardView__3IWZV .navCard_navBg__1z0Q_.navCard_navWhiteBg__3_9N7 {
			box-shadow: 0 2px 4px 0 rgba(203, 206, 216, .2);
			background: #fff;
			opacity: 1
		}

		.navCard_containerView {
			position: relative;
			width: 100%;
			height: 100%
		}

		.navCard_containerView .navCard_wrapperView {
			width: 100%;
			height: 100%;
			display: -webkit-flex;
			display: flex;
			position: relative;
			z-index: 100
		}

		.navCard_containerView .navCard_wrapperView .navCard_navLeftView,
		.navCard_containerView .navCard_wrapperView .navCard_navRightView__3irKJ {
			-webkit-flex: 1 1;
			flex: 1 1;
			position: relative
		}

		.navCard_navCenterView {
			position: relative;
			width: 1200px;
			height: 100%;
			-webkit-justify-content: space-between;
			justify-content: space-between
		}

		.navCard_navCenterView,
		.navCard_navCenterView .navCard_sectionLeftView {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center
		}

		.navCard_navCenterView .navCard_sectionLeftView .navCard_logoIcon {
			width: auto;
			height: 40px;
			cursor: pointer
		}

		.navCard_navCenterView .navCard_sectionLeftView .navCard_navListView {
			margin-left: 24px;
			font-size: 14px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			height: 100%
		}

		.navCard_navCenterView .navCard_sectionRightView {
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center
		}

		.navCard_secondNavbarView__2TD0D {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 390px;
			padding-top: 90px;
			background-color: #fff;
			overflow: hidden;
			-webkit-transition: opacity .8s ease, -webkit-transform .5s ease;
			transition: opacity .8s ease, -webkit-transform .5s ease;
			transition: transform .5s ease, opacity .8s ease;
			transition: transform .5s ease, opacity .8s ease, -webkit-transform .5s ease;
			z-index: 80;
			-webkit-transform: translateY(-100%);
			transform: translateY(-100%);
			opacity: 0;
			// background-image: url(/_next/static/media/background-navbar@2x.282c35efca18f1fe0c79a4b42b424f47.png);
			background-size: 100% 390px;
			background-position: top
		}

		.navCard_secondNavbarView__2TD0D.navCard_showNavView__1SS1c {
			-webkit-transform: translateY(0);
			transform: translateY(0);
			opacity: 1;
			box-shadow: 0 6px 19px 0 hsla(0, 0%, 40%, .27)
		}

		.navCard_secondNavbarView__2TD0D .navCard_secondNavView__16hF8 {
			width: 1200px;
			height: 100%;
			margin: 0 auto;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			overflow: hidden
		}

		.formItem_formItemView__1sM05 {
			position: relative;
			display: -webkit-flex;
			display: flex;
			text-align: left;
			-webkit-flex: none;
			flex: none
		}

		.formItem_formItemView__1sM05 .ant-form-item {
			margin-bottom: 16px
		}

		.formItem_formItemView__1sM05 .ant-form-item label:before {
			display: none !important
		}

		.formItem_formItemView__1sM05 .ant-form-item-with-help {
			margin-bottom: 0
		}

		.formItem_formItemView__1sM05 .ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
			border: 1px solid #e4eaff !important
		}

		.formItem_formItemView__1sM05 .ant-form-item-explain {
			height: 16px;
			min-height: 16px;
			font-size: 12px;
			text-align: left
		}

		.formItem_formItemView__1sM05 .ant-form-item-explain-error {
			color: #db6372
		}

		.formItem_formItemView__1sM05 .ant-input-affix-wrapper {
			padding: 5px 12px;
			box-shadow: none;
			border-color: #dfeafa
		}

		.formItem_formItemView__1sM05 .ant-input-affix-wrapper:hover {
			border-color: #dfeafa
		}

		.formItem_formItemView__1sM05 .formItem_tipText__3aSM2 {
			padding-bottom: 16px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			overflow: hidden
		}

		.formItem_formItemView__1sM05 label {
			color: #444c64
		}

		.codeButton_codeButtonView__jm-xb {
			color: #4176fa;
			padding: 0 10px;
			-webkit-transition: all .3s;
			transition: all .3s;
			cursor: pointer;
			right: 8px;
			top: 10px;
			margin: auto
		}

		.codeButton_codeButtonView__jm-xb,
		.codeButton_codeButtonView__jm-xb .codeButton_loadingIcon__3eSFt {
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-align-items: center;
			align-items: center;
			position: absolute
		}

		.codeButton_codeButtonView__jm-xb .codeButton_loadingIcon__3eSFt {
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			cursor: not-allowed
		}

		.codeButton_codeButtonView__jm-xb.codeButton_disabledView__209fl {
			opacity: .5;
			cursor: no-drop
		}

		.codeButton_codeButtonView__jm-xb.codeButton_noDrop__Zj7uF {
			color: #8a96a9;
			cursor: no-drop
		}

		.voiceCode_voiceCodeView__3noaA {
			font-size: 12px;
			color: #a5a9b3;
			margin-left: 94px;
			margin-bottom: 10px;
			position: relative;
			z-index: 9
		}

		.voiceCode_voiceCodeView__3noaA span {
			cursor: pointer
		}

		.voiceCode_voiceCodeView__3noaA em {
			color: #4176fa;
			cursor: pointer;
			font-style: normal
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt {
			padding-top: 24px;
			padding-bottom: 32px
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_buttonView__2Rj20 {
			margin: 0 auto;
			width: 320px
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_buttonTView__3_nET {
			margin: 0 auto;
			width: 150px
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_quitBtnView__10fU0 {
			margin: 0 auto;
			width: 150px;
			border: 1px solid #4176fa;
			background: #fff
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_quitBtnView__10fU0 span {
			color: #4176fa
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 {
			text-align: center;
			width: 320px;
			position: relative;
			margin: 0 auto
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .components_buttons__3Ao2y {
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-around;
			justify-content: space-around
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .components_inputItemView__1wMXP {
			width: 100% !important
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .ant-form-item {
			width: 320px;
			margin-bottom: 16px
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .ant-form-item input::-webkit-input-placeholder,
		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .ant-form-item input:placeholder-shown {
			font-size: 14px
		}

		.components_bindView__1guVd .components_bindFormView__3YVBt .components_modalFormItemView__10YB4 .ant-form-item .ant-form-item-explain {
			font-size: 14px;
			margin-top: 4px
		}

		.components_bindView__1guVd .components_tip__11pZX {
			font-size: 14px;
			color: #414655;
			text-align: center;
			margin: 0 auto 16px
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P {
			width: 450px;
			height: 90px
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .ant-form-item {
			width: 100%
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .ant-form-item label {
			color: #676b77
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .ant-form-item input::-webkit-input-placeholder,
		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .ant-form-item input:placeholder-shown {
			font-size: 14px;
			color: #6c7ba8
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .ant-form-item .ant-form-item-explain {
			font-size: 14px
		}

		.components_bindView__1guVd .components_changePwdFormItemView__3SH9P .components_changePwdInputItemView__XcyXv {
			width: 100%
		}

		.components_bindView__1guVd .components_changeButtonView__10ya3 {
			width: 450px;
			height: 50px;
			margin: 30px auto 0;
			text-align: center;
			line-height: 50px
		}

		.components_bindView__1guVd .components_voiceCodeView__1WWHR {
			font-size: 14px;
			color: #6a7391;
			width: 320px;
			position: relative;
			margin: 5px auto 14px
		}

		.importantNoticeModal_modal__3nTog {
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, .3);
			position: fixed;
			left: 0;
			top: 0;
			overflow: hidden;
			z-index: 1300
		}

		.importantNoticeModal_modal__3nTog .importantNoticeModal_modal_main__1EAkS {
			position: relative;
			width: 360px;
			min-height: 179px;
			border-radius: 4px;
			box-sizing: border-box;
			-webkit-tap-highlight-color: transparent;
			-webkit-touch-callout: none;
			-webkit-user-select: none;
			z-index: 999;
			top: 50%;
			margin: -117px auto 0;
			background: #fff
		}

		.importantNoticeModal_header__H0u2z {
			position: relative;
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-radius: 4px 4px 0 0;
			background: -webkit-linear-gradient(left, #d2b496, #dccab8);
			background: linear-gradient(90deg, #d2b496, #dccab8);
			border-bottom: 1px solid #fff
		}

		.importantNoticeModal_header__H0u2z .importantNoticeModal_text__sxHx6 {
			height: 40px;
			line-height: 40px;
			padding: 0 40px 0 16px;
			font-size: 18px;
			color: #fff
		}

		.importantNoticeModal_header__H0u2z .importantNoticeModal_close_icon__1wDYf {
			position: absolute;
			right: 16px;
			top: 50%;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
			width: 16px;
			z-index: 1000;
			height: 16px;
			// background-image: url(/_next/static/media/icon_closed.b4ca8bb39ee6465dec25a35bfbdb1654.png);
			background-position: 50%;
			background-size: contain;
			cursor: pointer
		}

		.importantNoticeModal_modal_content__ZUsv7 {
			width: 100%;
			padding: 27px 15px 32px;
			box-sizing: border-box;
			background-color: #f0f6ff
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_modal_statusIcon__YnANC {
			width: 36px;
			height: 36px;
			margin: 0 auto 22px
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_modal_statusIcon__YnANC.importantNoticeModal_statusSuccess__AnTbG {
			// background-image: url(/_next/static/media/success_icon.e553accc13c9cdf40e3701126aac0efc.svg);
			background-position: 50%;
			background-size: contain
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_modal_statusIcon__YnANC.importantNoticeModal_statusError__QNa9F {
			// background-image: url(/_next/static/media/icon_fail_modal.4dde7c52b6d598e5b4b30a7daa8a19ee.png);
			background-position: 50%;
			background-size: contain
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_modal_statusIcon__YnANC.importantNoticeModal_statusInfo__2tz2G {
			// background-image: url(/_next/static/media/icon_info_modal.1342520c619dc807eabf1dbf373ce3da.png);
			background-position: 50%;
			background-size: contain
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_messageBox__1W_eU {
			text-align: center;
			color: #666;
			font-size: 14px;
			line-height: 18px;
			word-break: break-word
		}

		.importantNoticeModal_modal_content__ZUsv7 .importantNoticeModal_messageBox__1W_eU p {
			max-height: 150px;
			overflow-y: auto;
			text-align: left
		}

		.importantNoticeModal_modal-content__uarXK::-webkit-scrollbar {
			display: none
		}

		.importantNoticeModal_modal_foot__2ia5W {
			display: -webkit-flex;
			display: flex;
			-webkit-flex-flow: row nowrap;
			flex-flow: row nowrap;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-align-items: center;
			align-items: center;
			width: 100%;
			padding-bottom: 24px;
			box-sizing: border-box;
			margin: 0 auto
		}

		.importantNoticeModal_modal_foot__2ia5W button {
			width: 136px;
			height: 38px;
			line-height: 38px;
			border: none;
			border-radius: 20px;
			text-align: center;
			font-size: 14px;
			color: #fff
		}

		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn1__16pO8 {
			float: left;
			background-size: 100%;
			background: #fff;
			color: #666;
			border: 1px solid #e0e0e0
		}

		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn2__Bpguc {
			float: right;
			background-size: 100%;
			margin-left: 16px;
			box-shadow: 0 4px 6px 4px rgba(219, 198, 177, .24)
		}

		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn2__Bpguc,
		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn2__Bpguc:hover {
			background: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background: linear-gradient(90deg, #62b3ff, #3d72fa);
			color: #fff !important
		}

		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn3__3wrIc {
			box-shadow: 0 4px 6px 4px rgba(219, 198, 177, .24)
		}

		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn3__3wrIc,
		.importantNoticeModal_modal_foot__2ia5W .importantNoticeModal_btn3__3wrIc:hover {
			background: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background: linear-gradient(90deg, #62b3ff, #3d72fa);
			color: #fff !important;
			color: #fff
		}

		.importantNoticeModal_success_bgColor__1Q0wS {
			background-color: #33abff
		}

		.importantNoticeModal_error_bgColor__17ens {
			background-color: #ee5a5b
		}

		.importantNoticeModal_modal_main__1EAkS {
			-webkit-animation: importantNoticeModal_Tada__35TQO .2s both;
			animation: importantNoticeModal_Tada__35TQO .2s both;
			-webkit-animation-fill-mode: forwards;
			animation-fill-mode: forwards;
			-webkit-animation-direction: 0;
			animation-direction: 0
		}

		@-webkit-keyframes importantNoticeModal_Tada__35TQO {
			0% {
				-webkit-transform: scale(.7);
				transform: scale(.7)
			}

			to {
				-webkit-transform: scale(1);
				transform: scale(1)
			}
		}

		@keyframes importantNoticeModal_Tada__35TQO {
			0% {
				-webkit-transform: scale(.7);
				transform: scale(.7)
			}

			to {
				-webkit-transform: scale(1);
				transform: scale(1)
			}
		}

		.importantNoticeModal_messageBox__1W_eU {
			-webkit-flex: 1 1;
			flex: 1 1
		}

		.importantNoticeModal_modal_HomeAreat__b0I0u {
			background-repeat: no-repeat;
			background-size: cover;
			background-position: 0 0;
			width: 612px;
			height: 370px;
			border-radius: 4px;
			border-radius: .16rem;
			background-size: 100% auto
		}

		.importantNoticeModal_modal_HomeAreat__b0I0u,
		.importantNoticeModal_modal_HomeAreat_model__3yG7q {
			box-sizing: border-box;
			position: relative;
			-webkit-tap-highlight-color: transparent;
			-webkit-touch-callout: none;
			-webkit-user-select: none;
			z-index: 1000;
			top: 40%;
			margin: -184px auto 0
		}

		.importantNoticeModal_modal_HomeAreat_model__3yG7q {
			width: 490px;
			height: 209px;
			border-radius: 8px
		}

		.importantNoticeModal_alert_dialog__2t_4N {
			width: 612px;
			height: 370px;
			border: none;
			position: absolute;
			box-shadow: none
		}

		.importantNoticeModal_alert_dialog__2t_4N ::-webkit-scrollbar {
			width: 6px !important
		}

		.importantNoticeModal_alert_dialog__2t_4N ::-webkit-scrollbar-track {
			border-radius: 3px
		}

		.importantNoticeModal_alert_dialog__2t_4N ::-webkit-scrollbar-thumb {
			border-radius: 3px;
			background: #eee
		}

		.importantNoticeModal_alert_dialog__2t_4N ::-webkit-scrollbar-thumb:window-inactive {
			background: #eee
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_el-dialog__close__7OH4j {
			display: none
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_el-dialog__body__EmOBC {
			padding: 15px 37px
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_el-dialog__header__MVsGC {
			text-align: center
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_el-dialog__header__MVsGC .importantNoticeModal_el-dialog__title__IMX81 {
			font-size: 18px;
			color: #fff;
			display: block
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_button__3iXpi {
			width: 106px;
			height: 30px;
			line-height: 5px;
			margin-top: 10px;
			margin-left: 220px;
			color: #fff;
			background-color: #409eff;
			border: #409eff;
			-webkit-transition: .1s;
			transition: .1s;
			padding: 12px 20px;
			float: left;
			font-size: 14px;
			border-radius: 4px
		}

		.importantNoticeModal_alert_dialog__2t_4N .importantNoticeModal_button__3iXpi:hover {
			background-color: #5dc2ff
		}

		.importantNoticeModal_dialog_header__53F9K {
			text-align: center;
			margin-top: 18px;
			position: relative;
			height: 46px;
			line-height: 46px;
			top: 0
		}

		.importantNoticeModal_dialog_header__53F9K span {
			font-size: 18px;
			color: #fff;
			display: block;
			margin-top: 8px
		}

		.importantNoticeModal_bottom__T3lwh {
			margin-left: 40px;
			float: left;
			height: 50px;
			cursor: pointer;
			line-height: 50px
		}

		.importantNoticeModal_bottom__T3lwh #importantNoticeModal_checkBox__1FKkY {
			width: 19px;
			height: 19px;
			border: #3db5ff;
			float: left
		}

		.importantNoticeModal_bottom__T3lwh div {
			font-size: 14px;
			color: #565454;
			float: right
		}

		.importantNoticeModal_bottom__T3lwh .importantNoticeModal_closes__3tLOM {
			margin-left: 8px;
			width: 186px
		}

		.importantNoticeModal_redomain__1-ev3 {
			color: #606266;
			font-size: 16px;
			line-height: 30px
		}

		.importantNoticeModal_dialogContent__Zq2FA {
			color: #333;
			padding: 0 75px;
			height: 238px;
			display: -webkit-flex;
			display: flex
		}

		.importantNoticeModal_dialogContent__Zq2FA p {
			padding: 20px 12px 0
		}

		.importantNoticeModal_dialogContent__Zq2FA p a {
			color: #33abff
		}

		.importantNoticeModal_dialog_footer__1148Q {
			height: 50px;
			display: -webkit-flex;
			display: flex;
			line-height: 50px
		}

		.importantNoticeModal_home_alert_dialog_model__3C5iP {
			height: auto;
			border-radius: 4px;
			background: #fff
		}

		.importantNoticeModal_notice_header__3_58o {
			position: relative;
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-radius: 4px 4px 0 0;
			background: -webkit-linear-gradient(left, #d2b496, #dccab8);
			background: linear-gradient(90deg, #d2b496, #dccab8);
			margin-bottom: 23px
		}

		.importantNoticeModal_notice_header__3_58o .importantNoticeModal_text__sxHx6 {
			height: 40px;
			line-height: 40px;
			padding: 0 40px 0 16px;
			font-size: 18px;
			color: #fff
		}

		.importantNoticeModal_notice_header__3_58o .importantNoticeModal_close_icon__1wDYf {
			position: absolute;
			right: 16px;
			top: 50%;
			-webkit-transform: translateY(-50%);
			transform: translateY(-50%);
			width: 16px;
			z-index: 1000;
			height: 16px;
			// background-image: url(/_next/static/media/icon_closed.b4ca8bb39ee6465dec25a35bfbdb1654.png);
			background-position: 50%;
			background-size: contain;
			cursor: pointer
		}

		.importantNoticeModal_notice_header__3_58o .importantNoticeModal_text__sxHx6 {
			display: block;
			cursor: pointer;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis
		}

		.importantNoticeModal_notice_content__3BPhr {
			min-height: 170px;
			max-height: 374px
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd {
			height: 64px;
			line-height: 64px;
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: space-between;
			justify-content: space-between;
			-webkit-align-items: center;
			align-items: center
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd .importantNoticeModal_btn_wrap__Azek6 {
			height: 36px;
			margin: 0 auto
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd .importantNoticeModal_btn_wrap__Azek6 button {
			font-size: 14px;
			color: #666;
			width: 130px;
			height: 36px;
			line-height: 34px;
			border-radius: 4px;
			vertical-align: top
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd .importantNoticeModal_btn_wrap__Azek6 .importantNoticeModal_close__n1qI1 {
			border: 1px solid #468aff;
			background-color: initial;
			color: #468aff
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd .importantNoticeModal_btn_wrap__Azek6 .importantNoticeModal_confirm___M-K9 {
			border: none;
			margin-left: 20px;
			color: #fff;
			background: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background: linear-gradient(90deg, #62b3ff, #3d72fa);
			color: #fff !important
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_no_more_tips__14rJd .importantNoticeModal_btn_wrap__Azek6 .importantNoticeModal_confirm___M-K9:hover {
			background: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background: linear-gradient(90deg, #62b3ff, #3d72fa);
			color: #fff !important
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_notice_content__3BPhr {
			position: relative;
			height: 209px;
			padding: 20px 8px 0 16px;
			border-bottom: 1px solid #ededed;
			box-sizing: border-box;
			overflow-y: auto
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_notice_content__3BPhr ::-webkit-scrollbar {
			width: 6px !important
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_notice_content__3BPhr ::-webkit-scrollbar-thumb {
			border-radius: 3px;
			background: #eee
		}

		.importantNoticeModal_notice_content__3BPhr .importantNoticeModal_notice_content__3BPhr ::-webkit-scrollbar-thumb:window-inactive {
			background: #eee
		}

		.importantNoticeModal_notice_content__3BPhr div ul {
			width: 100%;
			height: 100%;
			overflow-y: auto;
			scrollbar-color: transparent transparent;
			scrollbar-track-color: transparent;
			-ms-scrollbar-track-color: transparent
		}

		.importantNoticeModal_notice_content__3BPhr ul li {
			position: relative;
			margin-bottom: 20px;
			padding: 0 13px;
			box-sizing: border-box
		}

		.importantNoticeModal_notice_content__3BPhr ul li:after {
			content: "";
			position: absolute;
			left: 0;
			top: 5px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: rgba(65, 118, 250, .5)
		}

		.importantNoticeModal_notice_content__3BPhr ul li .importantNoticeModal_title__XrjB9 {
			line-height: 18px;
			font-size: 14px;
			color: #4176fa;
			margin-bottom: 2px
		}

		.importantNoticeModal_notice_content__3BPhr ul li .importantNoticeModal_content__3t88x {
			line-height: 18px;
			font-size: 14px;
			color: #666
		}

		.importantNoticeModal_line__2XRAx {
			width: 100%;
			height: 1px;
			background: #ededed;
			margin-bottom: 9px
		}

		.importantNoticeModal_notice_content__3BPhr div ul ::-webkit-scrollbar {
			width: 6px !important
		}

		.importantNoticeModal_notice_content__3BPhr div ul ::-webkit-scrollbar-track {
			border-radius: 3px
		}

		.importantNoticeModal_notice_content__3BPhr div ul ::-webkit-scrollbar-thumb {
			border-radius: 3px;
			background: #eee
		}

		.importantNoticeModal_notice_content__3BPhr div ul ::-webkit-scrollbar-thumb:window-inactive {
			background: #eee
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl {
			width: 490px;
			height: auto;
			background-color: #fff
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl .importantNoticeModal_notice_content__3BPhr {
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl .importantNoticeModal_flex__2x8NJ {
			white-space: pre-wrap;
			position: relative;
			margin-bottom: 23px;
			padding: 0 16px;
			box-sizing: border-box;
			line-height: 22px;
			min-height: 65px;
			max-height: 273px;
			font-size: 14px
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl .importantNoticeModal_footer__1bLUo {
			display: -webkit-flex;
			display: flex;
			-webkit-justify-content: center;
			justify-content: center;
			-webkit-align-items: center;
			align-items: center;
			height: 82px;
			border-top: 1px solid #efeff4
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl button {
			width: 136px;
			height: 38px;
			line-height: 38px;
			border: none;
			border-radius: 20px;
			text-align: center;
			font-size: 14px;
			color: #666;
			box-sizing: border-box
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl button.importantNoticeModal_confirm___M-K9 {
			color: #fff
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl button.importantNoticeModal_confirm___M-K9,
		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl button.importantNoticeModal_confirm___M-K9:hover {
			background: -webkit-linear-gradient(left, #62b3ff, #3d72fa);
			background: linear-gradient(90deg, #62b3ff, #3d72fa);
			color: #fff !important
		}

		.importantNoticeModal_modal_CuorsterAreat_model__DNhNl button.importantNoticeModal_close__n1qI1 {
			margin-right: 32px;
			background: #fff;
			color: #666;
			border: 1px solid #e0e0e0
		}

		.importantNoticeModal_modalWrapper__3eV9K .ant-modal-mask .ant-modal-wrap .ant-modal {
			background: red
		}

		.layout_appLayoutView__1-MC9 {
			min-height: 100vh;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-direction: column;
			flex-direction: column;
			background: #f0f6ff
		}

		.layout_appLayoutView__1-MC9>div {
			-webkit-flex: none;
			flex: none
		}
	}
</style>
